import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

/**
 * Preserve Travel snowflake IDs that exceed Number.MAX_SAFE_INTEGER.
 * Collaboration timeline JSON may emit timelineItemId / sourceId as bare numbers.
 */
function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:journeyId|timelineItemId|sourceId|actorMemberId|cursorTimelineItemId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

function listConfig(cursor = {}) {
  const params = {};
  if (cursor.limit != null) params.limit = cursor.limit;
  if (cursor.cursorSortTime && cursor.cursorTimelineItemId) {
    params.cursorSortTime = cursor.cursorSortTime;
    params.cursorTimelineItemId = cursor.cursorTimelineItemId;
  }
  return { ...snowflakeJson, params };
}

export const journeyCollaborationTimelineApi = {
  list: (journeyId, cursor) => travelClient.get(
    travelEndpoints.journeyCollaborationTimeline(journeyId),
    listConfig(cursor),
  ),
};
